module.exports = __webpack_public_path__ + "static/media/elev-01.330ac3f6.svg";